import PostsContent from './PostsContent'

export default PostsContent